export { AnonymousPlayerView } from './AnonymousPlayerView'
